export const MAIN = {
  PRIMARY: '#f5651c', //orange
  SECONDARY: '#00457f',
} as const;

export const MAIN_HOVER = {
  PRIMARY_HOVER: '#db510b',
  SECONDARY_HOVER: '#00457f',
} as const;

export const BW = {
  BLACK: '#000',
  WHITE: '#fff',
} as const;

export const GREY_SCALE = {
  GREY_1: '#f8f9fa',
  GREY_2: '#f5f7fa',
  GREY_3: '#e9edf3',
  GREY_4: '#d3dae6',
  GREY_5: '#98a2b3',
  GREY_6: '#69707d',
  GREY_7: '#343741',
} as const;

export const ALERTING = {
  SUCCESS: '#27ae60',
  ALERT: '#fac342',
  ERROR: '#d94c4c',
} as const;

export const FILTERS = {
  FILTERS_PRIMARY: '#F9A377',
  FILTERS_SECONDARY: '#00457f',
  FILTERS_VARIANT: '#A3A2AC',
} as const;

export const THEME = {
  ...MAIN,
  ...MAIN_HOVER,
  ...BW,
  ...GREY_SCALE,
  ...ALERTING,
  ...FILTERS,
} as const;
